import React from 'react';
import './FooterIT.css';
import { Link } from 'react-router-dom';

const FooterIT = ({ translations }) => {
  return (
    <div className="sr-footer">
      <div>
        COMPLETA 25 OFFERTE PER RICHIEDERE UN INCENTIVO DI 1000€ O COMPLETA MENO OFFERTE 
        PER RICHIEDERE INCENTIVI DI VALORE INFERIORE. DISPONIBILE TRAMITE BONIFICO BANCARIO 
        E CARTE REGALO.
      </div>
      <div>
        *AL COMPLETAMENTO DELL'ACQUISTO E DEI REQUISITI DEL PROGRAMMA. I nomi commerciali o 
        i diritti associati a tutti i marchi su questo sito sono di proprietà dei rispettivi 
        proprietari e non sono affiliati con questa promozione.
      </div>
      <div className="footer-links">
        <Link to="/it/privacy" target="_blank" rel="noopener noreferrer">
          Informativa sulla Privacy
        </Link>
        {' | '}
        <Link to="/it/termini" target="_blank" rel="noopener noreferrer">
          Termini e Condizioni
        </Link>
      </div>
      <div className="footer-copyright">
        © 2026 Rewards & Samples, LLC. Tutti i diritti riservati.
      </div>
    </div>
  );
};

export default FooterIT;
